import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';

export function ContentCodeBlockView() {
  return (
    <NodeViewWrapper className="group relative flex items-start justify-end justify-self-center">
      <div
        className="font-body-2-m absolute -left-7 top-0 select-none text-branding-gray-600 group-hover:hidden"
        contentEditable={false}
      >
        C
      </div>
      <NodeViewContent className="w-full max-w-[800px] font-mono"></NodeViewContent>
    </NodeViewWrapper>
  );
}
